<template>
    <div class="main">
        <van-swipe v-if="imgList.length > 0" class="my-swipe" :autoplay="5000" indicator-color="white">
            <van-swipe-item @click="linkTo(item)" v-for="(item, index) in imgList" :key="index">
                <van-image width="100%" fit="cover" :src="item.imgUrl" />
            </van-swipe-item>
        </van-swipe>
        <base-table-list :apiConfig="baseTableList.apiConfig" :params="baseTableList.params" ref="list">
            <template v-slot:item="scope">
                <div class="report-box" @click="linkTo(scope.row)">
                    <div class="report-img">
                        <van-image style="float: left;" width="100%" fit="contain" :src="scope.row.imgUrl" />
                    </div>
                    <div v-if="scope.row.desc" class="report-name">
                        {{ scope.row.desc }}
                    </div>
                </div>
            </template>
        </base-table-list>
    </div>
</template>

<script>
import BaseTableList from "@/components/BaseTableList/index.vue";
import * as api from '@/axios/PublicBanner/index.js'
export default {
    components: {
        BaseTableList
    },
    data() {
        return {
            baseTableList: {
                apiConfig: {
                    url: "/api/dm/market/study-resource/getResourceList",
                    method: "get",
                },
                params: {

                },
            },
            imgList: []
        }
    },
    computed() {

    },
    mounted() {
        this.getBannerList()
    },
    methods: {
        getBannerList() {
            api.getBannerList().then(res => {
                const { errcode, errmsg, data } = res
                if (errcode !== 0) throw errmsg
                this.imgList = data.filter(item => item.isDisplay == 1)
            }).catch(e => {
                this.$toast(e)
            })
        },
        linkTo(item) {
            const { linkUrl } = item
            if (!linkUrl) {
                return
            }
            window.open(linkUrl)
        }
    }
}
</script>

<style lang="scss" scoped>
.main {
    height: 100%;
    width: 100%;
    background-color: #f5f5f7;

    /deep/ .van-list {
        height: 100%;
        background-color: #f5f5f7;
        padding: 10px;
        column-count: auto;
        column-width: 150px;   //单个子元素宽度
    }

    .report-box {
        position: relative;
        padding-bottom: 10px;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .report-name {
            background-color: #fff;
            height: auto;
            font-size: 14px;
            padding: 8px 6px;
            font-weight: 500;
            border-radius: 8px;
        }
    }
}
</style>
